import { useContext } from "react";
import AuthContext from "../context/AuthProvider";
import { useLayoutMode } from "./LayoutModeContext";

// Renders the desktop variant of a page only when the desktop shell is active.
const ModeSwitch = ({ classic, desktop }) => {
  const { isDesktop } = useLayoutMode();
  const { auth } = useContext(AuthContext);
  return isDesktop && auth?.user ? desktop : classic;
};

export default ModeSwitch;
